import { Paper } from '@material-ui/core';
import React from 'react';
import data from '../../../utils/dbSchema';
import Layout from '../../Layout';
import { Box } from '../../UI';
import Carousel from '../../UI/Carousel';
import images from '../../UI/images';
import Map from '../../UI/Map';
import Modal from './Modal';
import NDA from './NDA';
import Summary from './Summary';
import PageTitle from '../../Layout/PageTitle';
import NavigateBack from '../../UI/NavigateBack';

export default function Asset({ match }) {
	const [isOpen, setIsOpen] = React.useState(false);
	const [acceptedTerms, setAcceptedTerms] = React.useState(localStorage.getItem('terms'));

	const handleAcceptTerms = () => {
		setIsOpen(false);
		setAcceptedTerms(true);
		localStorage.setItem('terms', 'true');
	};

	const propertyData = data.properties.find(property => {
		return match.params.propertyId === property.id;
	});

	return (
		<Layout>
			<Box display="flex" flexDirection="column" p="35px">
				<PageTitle title={`${propertyData.id}`} subtitle={`${propertyData.sell.address}`} action={<NavigateBack slug={`/market-search`}/>}/>
				<Box width="100%" display="flex" flexDirection="row">
					<Box width="50%" pr={'15px'} display="flex" flexDirection="column" alignItems="stretch">
						<Box>
							<Paper>
								<Carousel images={images[propertyData.index]} height="450px" />
							</Paper>
						</Box>
						<Box mt="15px">
							<Paper>
								<Map center={propertyData.coords} height="400px" />
							</Paper>
						</Box>
					</Box>
					<Box width="50%">
						<Summary
							propertyData={propertyData}
							acceptedTerms={acceptedTerms === 'true' || acceptedTerms === true}
						/>
						<NDA
							acceptedTerms={acceptedTerms === 'true' || acceptedTerms === true}
							setIsOpen={setIsOpen}
							match={match}
							description={propertyData.description}
						/>
					</Box>
				</Box>
			</Box>
			{isOpen && <Modal isOpen={isOpen} setIsOpen={setIsOpen} handleAcceptTerms={handleAcceptTerms} />}
		</Layout>
	);
}
